/**
 * Internal dependencies
 */
import { SET_HERO_DOT } from '../actionTypes';
import { createAction } from '../action-creators';
import { RootState } from '../types';

export const setHeroDot = createAction<RootState['heroDot']>(SET_HERO_DOT);
